import { formatDate } from '../../libs/date';
import { parseError } from '../../libs/parser';
import CommonDescription from '../../components/CommonDescription';
import Context from '../../provider';
import IconEmail from '../../assets/hkdc/icons/EmailIcon';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import React, { useContext, useState } from 'react';
import memberApi from '../../libs/api/memberApi';
import './index.scss';

export default function NotificationItemComponent(props) {
  const {
    item,
    isLast,
    isMobile = true
  } = props;

  const { lang, dispatch, me } = useContext(Context);
  const [read, setRead] = useState(false);
  const [show, setShow] = useState(false);

  const fetchSetNotificationRead = async (id) => {
    try {
      const response = await memberApi.setNotificationToRead({ readId: id });

      if (response) {
        setRead(true);
      }

    } catch (error) {
      dispatch({
        type: 'SET_ERROR_DIALOG',
        payload: { open: true, ...parseError(error) }
      });
    }
  };

  const setNotification = (id) => {
    setShow(!show);
    if (me?.status === 'activated' && !item.read) {
      fetchSetNotificationRead(id);
    }
  };

  return (
    <div className={`${isMobile ? 'mobile' : 'web'}-notification-item-cont`}
      style={{ borderBottom: !isLast ? '0.0625rem solid black' : undefined }}
    >
      <div className="content-container">
        <div className="email-icon-container">
          <IconEmail
            className={`icon${item.read || read ? ' read' : ''}`}
            size="large" />
        </div>
        <div className="content-text-cont">
          <div className="title-time-cont"
            onClick={(e) => {
              e.stopPropagation();
              if (item.page_ruri[lang]) {
                window.location.assign(item.page_ruri[lang]);
              }
            }
          }
          >
            <div className="title-text">
              {item.subject?.[lang]}
            </div>
            <div className="time-text">
              {formatDate(item.sent_at, lang)}
            </div>
          </div>
          {
            show &&
            <div className="content-text">
              <CommonDescription data={item.message?.[lang]} />
            </div>
          }
        </div>
      </div>
      <div className="icon-container"
        onClick={(e) => {
          e.stopPropagation();
          setNotification(item.id);
        }}
      >
        {
          show
          ?
          <KeyboardArrowUpIcon
            className="icon"
            size="large"
          />
          :
          <KeyboardArrowDownIcon
            className="icon"
            size="large" />
        }
      </div>
    </div>
  );
}